export const RtlLanguages = [ 'fa', 'ar', 'per', 'ara' ];